import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { CHAT_CONVERSATION_DELETE } from "./gql";

const useChatConversationDelete = createDefaultMutationHook(CHAT_CONVERSATION_DELETE);

export default useChatConversationDelete;
